// Staff (RBAC) auth helpers. Uses HTTP-only cookies set by /api/auth/login.
// withCredentials is required so the kl_access cookie travels with each call.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const staffApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// In-memory session cache — avoids re-hitting /auth/me on EVERY admin route
// change (each call was a 300-400ms blocking "Verifying session…" screen).
// The 8h JWT is still the source of truth; we just trust it locally for a
// short window and silently re-validate when the window expires.
const ME_CACHE_TTL_MS = 2 * 60 * 1000;
let _meCache = { user: null, ts: 0 };

export async function staffLogin(email, password) {
  const { data } = await staffApi.post("/auth/login", { email, password });
  _meCache = { user: data, ts: Date.now() };
  return data;
}

export async function staffMe({ fresh = false } = {}) {
  if (!fresh && _meCache.user && Date.now() - _meCache.ts < ME_CACHE_TTL_MS) {
    return _meCache.user;
  }
  try {
    const { data } = await staffApi.get("/auth/me");
    _meCache = { user: data, ts: Date.now() };
    try { sessionStorage.setItem("kl_staff_me", JSON.stringify({ role: data?.role, email: data?.email, name: data?.name })); } catch { /* private mode */ }
    return data;
  } catch {
    _meCache = { user: null, ts: 0 };
    return null;
  }
}

export function cacheStaffUser(user) {
  _meCache = { user, ts: Date.now() };
}

export async function staffLogout() {
  _meCache = { user: null, ts: 0 };
  try {
    await staffApi.post("/auth/logout");
  } catch {
    /* noop */
  }
}

export const isOwner = (u) => u?.role === "owner";
export const isInjector = (u) => u?.role === "injector";
